import { FormattedMessage } from 'react-intl';
import { Icon, Input, Modal, Popover, Spin, Table } from 'antd';
import en_us from 'rc-pagination/lib/locale/en_US';
import zh_cn from 'rc-pagination/lib/locale/zh_CN';
import { ENGLISH } from '../../utils/constants';
import { TriangleWrap } from '../Widgets';

export default ({ intl, dispatch, loading, customReport }) => {
  const {
    keywords,
    crName,
    crSql,
    showInfo,
    errorInfo,
    infoMsg,
    total,
    pageNo,
    sqlResult,
    reports,
    pageSize
  } = customReport;

  const kwShow = [];
  const level = Math.ceil(keywords.length / 5);
  let cnt = 0;
  while (cnt < level) {
    const subArr = keywords.slice(cnt * 5, cnt * 5 + 5);
    kwShow.push(<p key={Math.random()}>{subArr.join(', ')}</p>);
    cnt++;
  }

  // 查询结果的所有key值
  const keys = [];
  if (sqlResult.length > 0) {
    let hasId = false;
    for (const key in sqlResult[0]) {
      if (key.toLowerCase() === 'id') {
        hasId = true;
      } else if (key.toLowerCase() !== 'crunikey') {
        keys.push(key);
      }
    }
    keys.sort();
    // 如果有id字段，放在第一列
    if (hasId) {
      keys.unshift('id');
    }
  }

  sqlResult.forEach(sr => {
    // 给每条记录增加一个唯一的key值
    sr['crUniKey'] = Math.random();
  });

  const colWidth = 194;
  const columns = keys.map(k => {
    return {
      title: k,
      dataIndex: k,
      width: colWidth,
      key: k,
      render: text => (
        <span className="result-cell" title={text}>
          {text}
        </span>
      )
    };
  });

  const scrollObj = {
    x: keys.length > 8 ? colWidth * keys.length : false
  };

  const pagination = {
    total,
    onChange: page => {
      dispatch({ type: 'customReport/setState', payload: { pageNo: page } });
      dispatch({ type: 'customReport/excuteSQL' });
    },
    pageSize,
    current: pageNo,
    locale: intl.formatMessage({ id: 'locale' }) === ENGLISH ? en_us : zh_cn
  };

  return (
    <div className="container-left sys-config-container">
      <div className="container-user">
        <Spin spinning={loading} size="large">
          <div className="container-desk">
            <div className="user-information">
              <div className="user-right">
                <div className="right-title">
                  <div className="tabs-container">
                    <FormattedMessage id="report_custom" />
                  </div>
                  <TriangleWrap className="children-wrap custom-report">
                    <div className="custom-report-config">
                      <div className="custom-report-form">
                        <div className="form-line">
                          <span className="form-label">
                            <span className="star">*</span>
                            <FormattedMessage id="report_custom_name" />
                          </span>
                          <span className="form-item">
                            <Input
                              value={crName || ''}
                              maxLength="10"
                              placeholder={intl.formatMessage({
                                id: 'report_custom_name_placeholder'
                              })}
                              onChange={e => {
                                dispatch({
                                  type: 'customReport/setState',
                                  payload: { crName: e.target.value }
                                });
                              }}
                            />
                          </span>
                        </div>
                        <div className="form-line">
                          <span className="form-label">
                            <span className="star">*</span>
                            <FormattedMessage id="report_custom_sql" />
                            <p>
                              <Popover
                                placement="rightTop"
                                arrowPointAtCenter
                                title={intl.formatMessage({
                                  id: 'report_custom_sql_placeholder'
                                })}
                                content={kwShow}
                                trigger="hover"
                              >
                                <Icon type="question-circle-o" />
                              </Popover>
                            </p>
                          </span>
                          <span className="form-item">
                            <Input.TextArea
                              value={crSql || ''}
                              autosize={{ minRows: 10, maxRows: 10 }}
                              onChange={e => {
                                dispatch({
                                  type: 'customReport/setState',
                                  payload: {
                                    crSql: e.target.value,
                                    pageNo: 1,
                                    total: 0,
                                    sqlResult: []
                                  }
                                });
                              }}
                            />
                          </span>
                        </div>
                        <div className="form-line">
                          <span className="form-label" />
                          <span className="form-item">
                            {showInfo && (
                              <div
                                className={`result-info ${
                                  errorInfo ? 'error' : ''
                                }`}
                              >
                                {errorInfo ? (
                                  <Icon type="exclamation-circle" />
                                ) : (
                                  <Icon type="check-circle" />
                                )}
                                {infoMsg}
                              </div>
                            )}
                          </span>
                        </div>
                        <div className="form-line">
                          <span className="form-label" />
                          <span className="form-item">
                            <div
                              className="exc-btn"
                              onClick={() => {
                                dispatch({
                                  type: 'customReport/setState',
                                  payload: { pageNo: 1 }
                                });
                                dispatch({ type: 'customReport/excuteSQL' });
                              }}
                            >
                              <FormattedMessage id="report_custom_btn_excute" />
                            </div>
                            <div
                              className="save-btn"
                              onClick={() => {
                                dispatch({ type: 'customReport/save' });
                              }}
                            >
                              <FormattedMessage id="report_custom_btn_save" />
                            </div>
                          </span>
                        </div>
                      </div>
                      <div className="custom-report-list">
                        <div className="list-title">
                          <div
                            className="create-btn"
                            onClick={() => {
                              const payload = {
                                crId: 0,
                                crName: '',
                                crSql: '',
                                pageNo: 1,
                                total: 0,
                                sqlResult: []
                              };
                              dispatch({
                                type: 'customReport/setState',
                                payload
                              });
                            }}
                          >
                            + <FormattedMessage id="report_custom_add" />
                          </div>
                        </div>
                        <div className="list-body">
                          {reports &&
                            reports.map(r => (
                              <div className="list-row" key={r.id}>
                                <span className="report-name">{r.name}</span>
                                <span className="report-opt">
                                  <span
                                    onClick={() => {
                                      const payload = {
                                        crId: r.id,
                                        crName: r.name,
                                        crSql: r.script,
                                        pageNo: 1,
                                        total: 0,
                                        sqlResult: []
                                      };
                                      dispatch({
                                        type: 'customReport/setState',
                                        payload
                                      });
                                    }}
                                  >
                                    <FormattedMessage id="report_custom_view" />
                                  </span>
                                  <span
                                    onClick={() => {
                                      Modal.confirm({
                                        content: intl.formatMessage({
                                          id: 'report_custom_delete_confirm'
                                        }),
                                        onOk: () => {
                                          dispatch({
                                            type: 'customReport/delete',
                                            id: r.id
                                          });
                                        }
                                      });
                                    }}
                                  >
                                    <FormattedMessage id="report_custom_delete" />
                                  </span>
                                </span>
                              </div>
                            ))}
                        </div>
                      </div>
                    </div>
                  </TriangleWrap>
                  <TriangleWrap className="children-wrap custom-report">
                    <div className="custom-report-show">
                      <Table
                        rowKey={record => record.crUniKey}
                        columns={columns}
                        dataSource={sqlResult}
                        pagination={pagination}
                        scroll={scrollObj}
                      />
                    </div>
                  </TriangleWrap>
                </div>
              </div>
            </div>
          </div>
        </Spin>
      </div>
    </div>
  );
};



// WEBPACK FOOTER //
// ./src/components/report/CustomReport.js